/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import _ from 'lodash';

export const sortValues = (a, b) => {
  // Get first element of array values
  a = Array.isArray(a) ? a[0] : a;
  b = Array.isArray(b) ? b[0] : b;

  // Force null and undefined to the bottom
  a = a === null || a === undefined ? (isNaN(b) ? '' : -Infinity) : a;
  b = b === null || b === undefined ? (isNaN(a) ? '' : -Infinity) : b;

  // Force any string values to lowercase
  a = typeof a === 'string' ? a.toLowerCase() : a;
  b = typeof b === 'string' ? b.toLowerCase() : b;

  // Return either 1 or -1 to indicate a sort priority
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  // Returning 0, undefined or any falsey value will
  // use subsequent sorts or the index as a tiebreaker
  return 0;
};

export const sortRowValues = (a, b) => sortValues(a.value, b.value);

export const dateSort = (a, b) => {
  a = new Date(a).getTime();
  b = new Date(b).getTime();
  return a > b ? 1 : -1;
};

export const durationSort = (a, b) => {
  let hoursFirst;
  let minutesFirst;
  let addedDayFirst = 0;
  let hoursSecond;
  let minutesSecond;
  let addedDaySecond = 0;

  const dayFormatForFirst = a.includes('d ');
  hoursFirst = parseInt(_.first(a.split(':')), 10);
  minutesFirst = parseInt(_.last(a.split(':')), 10);
  if (dayFormatForFirst) {
    addedDayFirst = _.first(a.split('d '));
    const removedDay = _.last(a.split('d '));
    hoursFirst = parseInt(_.first(removedDay.split(':')), 10);
    minutesFirst = parseInt(_.last(removedDay.split(':')), 10);
  }
  const durationA = new Date();
  if (addedDayFirst < 0) {
    durationA.setHours((addedDayFirst * 24) - hoursFirst);
  } else {
    durationA.setHours((addedDayFirst * 24) + hoursFirst);
  }
  durationA.setMinutes(minutesFirst);

  const dayFormatForSecond = b.includes('d ');
  hoursSecond = parseInt(_.first(b.split(':')), 10);
  minutesSecond = parseInt(_.last(b.split(':')), 10);
  if (dayFormatForSecond) {
    addedDaySecond = _.first(b.split('d '));
    const removedDay = _.last(b.split('d '));
    hoursSecond = parseInt(_.first(removedDay.split(':')), 10);
    minutesSecond = parseInt(_.last(removedDay.split(':')), 10);
  }
  const durationB = new Date();
  if (addedDaySecond < 0) {
    durationB.setHours((addedDaySecond * 24) - hoursSecond);
  } else {
    durationB.setHours((addedDaySecond * 24) + hoursSecond);
  }
  durationB.setMinutes(minutesSecond);

  a = durationA.getTime();
  b = durationB.getTime();
  return a > b ? 1 : -1;
};
